// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__2M22V","cards":"Projects_cards__2Gw1a","buttonCreateProject":"Projects_buttonCreateProject__363jI"};